// extracted by mini-css-extract-plugin
module.exports = {"permissionsError":"PurchaseOrdersNav_permissionsError__4mOMD"};